/* ADORINSE — PDP gallery + lightbox
   1) The main product image ships with a `srcset` that overrides any `.src`
      update, so the built-in thumbnail handler can't switch it. We strip the
      srcset and swap `.src` directly on thumbnail click.
   2) Clicking the main image opens a fullscreen lightbox with prev/next,
      keyboard (Esc / arrows) and click-outside-to-close. Self-contained;
      only runs where a gallery exists. */
(function () {
  function init() {
    var mainWrap = document.querySelector('.gallery-main');
    var main = mainWrap && mainWrap.querySelector('img');
    if (!main) return;

    var thumbs = Array.prototype.slice.call(document.querySelectorAll('.thumbs .thumb'));
    var imgs = thumbs.map(function (t) { return t.getAttribute('data-thumb'); }).filter(Boolean);
    if (!imgs.length) imgs = [main.getAttribute('src')];
    var current = 0;

    function setMain(src, idx) {
      if (!src) return;
      main.removeAttribute('srcset');
      main.removeAttribute('sizes');
      main.src = src;
      if (typeof idx === 'number') {
        current = idx;
        thumbs.forEach(function (x, i) { x.classList.toggle('active', i === idx); });
      }
    }

    // Let .src control the displayed image from the start.
    main.removeAttribute('srcset');
    main.removeAttribute('sizes');

    thumbs.forEach(function (t, i) {
      t.addEventListener('click', function () { setMain(t.getAttribute('data-thumb'), i); });
    });

    /* ---------- lightbox ---------- */
    var lb = document.createElement('div');
    lb.className = 'pdp-lightbox';
    lb.setAttribute('role', 'dialog');
    lb.setAttribute('aria-modal', 'true');
    lb.innerHTML =
      '<div class="pdp-lightbox__stage">' +
        '<img class="pdp-lightbox__img" src="" alt="">' +
        '<button type="button" class="pdp-lightbox__btn pdp-lightbox__close" aria-label="Close">×</button>' +
        '<button type="button" class="pdp-lightbox__btn pdp-lightbox__nav pdp-lightbox__prev" aria-label="Previous">‹</button>' +
        '<button type="button" class="pdp-lightbox__btn pdp-lightbox__nav pdp-lightbox__next" aria-label="Next">›</button>' +
        '<span class="pdp-lightbox__count"></span>' +
      '</div>';
    document.body.appendChild(lb);

    var lbImg = lb.querySelector('.pdp-lightbox__img');
    var lbCount = lb.querySelector('.pdp-lightbox__count');
    var lbStage = lb.querySelector('.pdp-lightbox__stage');
    var navs = lb.querySelectorAll('.pdp-lightbox__nav');
    if (imgs.length < 2) { navs.forEach(function (n) { n.style.display = 'none'; }); }

    function bigSrc(src) {
      return src ? src.replace(/([?&])width=\d+/, '$1width=1600') : src;
    }
    function show(idx) {
      if (idx < 0) idx = imgs.length - 1;
      if (idx >= imgs.length) idx = 0;
      lbImg.src = bigSrc(imgs[idx]);
      lbCount.textContent = (idx + 1) + ' / ' + imgs.length;
      setMain(imgs[idx], idx);
    }
    function open() { show(current); lb.classList.add('open'); document.documentElement.style.overflow = 'hidden'; }
    function close() { lb.classList.remove('open'); document.documentElement.style.overflow = ''; }

    mainWrap.addEventListener('click', open);
    lb.querySelector('.pdp-lightbox__close').addEventListener('click', close);
    lb.querySelector('.pdp-lightbox__prev').addEventListener('click', function (e) { e.stopPropagation(); show(current - 1); });
    lb.querySelector('.pdp-lightbox__next').addEventListener('click', function (e) { e.stopPropagation(); show(current + 1); });
    lb.addEventListener('click', function (e) { if (!lbStage.contains(e.target)) close(); });
    document.addEventListener('keydown', function (e) {
      if (!lb.classList.contains('open')) return;
      if (e.key === 'Escape') close();
      else if (e.key === 'ArrowLeft') show(current - 1);
      else if (e.key === 'ArrowRight') show(current + 1);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
